import React, { useEffect, useState } from "react"
import C3Chart from "react-c3js"
import "c3/c3.css"
import { useSelector } from "react-redux"
import config from "config/config"
import axios from "axios"

const DonutChart = () => {
  const activeOrganization = useSelector(
    state => state.organizationReducer.activeOrganization,
  )

  const userData = useSelector(state => state.Login.userData)

  const [doctors, setDoctors] = useState([])
  const [reviews, setReviews] = useState([])
  const [chartData, setChartData] = useState([])

  const fetchReviews = async () => {
    try {
      const response = await axios.get(
        `${config.backendUrl}/healthgrade/getReviews?integrationId=${activeOrganization.HealthgradeIntegrations[0].id}`,
        {
          headers: {
            Authorization: `Bearer ${userData.token}`,
          },
        },
      )
      setReviews(response.data.reviews)
    } catch (err) {
      console.log(err)
    }
  }

  const fetchDoctors = async () => {
    try {
      const response = await axios.get(
        `${config.backendUrl}/healthgrade/getDoctors?integrationId=${activeOrganization.HealthgradeIntegrations[0].id}`,
        {
          headers: {
            Authorization: `Bearer ${userData.token}`,
          },
        },
      )
      setDoctors(response.data.doctors)
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    if (activeOrganization?.HealthgradeIntegrations?.length) {
      fetchDoctors()
      fetchReviews()
    }
  }, [activeOrganization])

  useEffect(() => {
    if (doctors.length > 0) {
      const doctorRatings = {}

      // Aggregate ratings
      reviews.forEach(review => {
        const doctorName = review.reviewsFor
        if (review.rating != null && !isNaN(review.rating)) {
          if (!doctorRatings[doctorName]) {
            doctorRatings[doctorName] = { totalRating: 0, reviewCount: 0 }
          }
          doctorRatings[doctorName].totalRating += review.rating
          doctorRatings[doctorName].reviewCount += 1
        }
      })

      // Compute average ratings
      const averagedRatings = doctors
        .map(doctor => {
          const name = doctor.name || "Unnamed Doctor"
          const ratingData = doctorRatings[name]
          if (ratingData && ratingData.reviewCount > 0) {
            return {
              name,
              avgRating: ratingData.totalRating / ratingData.reviewCount,
            }
          }
          return null
        })
        .filter(Boolean)

      // Find the top-rated doctor
      if (averagedRatings.length > 0) {
        const topDoctor = averagedRatings.reduce((a, b) =>
          a.avgRating > b.avgRating ? a : b,
        )

        // Fill donut: top doctor + empty remainder
        setChartData([
          [topDoctor.name, topDoctor.avgRating],
          ["Remaining", 5 - topDoctor.avgRating], // Assuming max rating = 5
        ])
      } else {
        setChartData([["No Ratings Available", 1]])
      }
    }
  }, [doctors, reviews])

  const data = {
    columns: chartData,
    type: "donut",
    // 👇 Disable default percentage text
    onclick: () => {},
    onmouseover: () => {},
    onmouseout: () => {},
  }

  const donut = {
    title: "Top Doctor Rating",
    width: 30,
    label: { show: false }, // hide labels
  }

  const color = {
    pattern: ["#F0F1F4", "#2990DF"], // blue + light gray
  }

  const size = {
    height: 300,
  }

  const onRendered = chart => {
    // 👇 Remove the default "percentage text" in the center
    const texts = document.querySelectorAll(".c3-chart-arcs-title")
    texts.forEach(t => {
      t.textContent = "" // remove "100%"
    })
  }

  return (
    <React.Fragment>
      <C3Chart
        data={data}
        donut={donut}
        color={color}
        size={size} 
        dir="ltr"
        onrendered={onRendered}
      />
    </React.Fragment>
  )
}

export default DonutChart
